module.exports = __webpack_public_path__ + "static/reactui-e7701e29865330ce87a15d46ff063c7d.svg";